<template>
  <div :class="containerClass">
    <input @keyup.enter="onSubmit" v-model="searchString" type="text" placeholder="Search the Retail (S-Series) Help Center" />
  </div>
</template>
<script>
export default {
  props: ['className'],
  data() {
    return {
      searchString: ''
    };
  },
  computed: {
    containerClass() {
      return `support-search ${this.className} support-search-input-box`;
    },
  },
  methods: {
    onSubmit() {
      window.location.href = `/support/search?searchString=${this.searchString}`;
    }
  }
};
</script>
